import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { setupStore } from './redux/store';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { StyledEngineProvider } from '@mui/material';
import setupSchoolMergeApiClientInterceptor from 'api/schoolMergeApiClientInterceptors';
import { schoolMergeApiClient } from 'api/schoolMergeApiClient';
import { schoolMergeAuthClient } from 'api/schoolMergeAuthClient';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const store = setupStore(schoolMergeApiClient, schoolMergeAuthClient);
setupSchoolMergeApiClientInterceptor(store);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <StyledEngineProvider injectFirst>
        <App />
      </StyledEngineProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
